import React from "react"
import clsx from "clsx"
import isClientSide from "~utils/is-client-side"
import * as styles from "./edit-page-button.module.css"

function getLocalStorage() {
  try {
    // Because this throws in iframe in incognito mode
    return window.localStorage
  } catch {
    return undefined
  }
}

const EditPageButton = ({ url, float }) => {
  if (!isClientSide() || !getLocalStorage() || !getLocalStorage().getItem("fastly-devhub-editor")) return null
  return (
    <a
      className={clsx(styles.button, { [styles.float]: Boolean(float) })}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      Edit this page
    </a>
  )
}

export default EditPageButton
